export const root = '@container/carousel';

export const item = [
  'basis-[90%]', // 1 in view, 1 partially
  '@xs/carousel:basis-[45%]', // 320px+ 2 in view, 1 partially
  '@xl/carousel:basis-1/3', // 576px+ 3 in view
  '@3xl/carousel:basis-1/4', // 1024px+ 4 in view
  '@7xl/carousel:basis-1/5' // 1280px+ 5 in view
];

export const baseButton = [
  'rounded-lg bg-[#fff]/70 p-3 shadow-[4px_8px_8px_0px_rgba(0,0,0,0.04)] transition-colors lumon:rounded-sm lumon:bg-gray-0 lumon:px-0 lumon:py-[10px]', // base
  'hover:bg-button-hover hover:text-icon-reversed lumon:hover:bg-gray-900 lumon:hover:text-gray-0', // hover
  'active:bg-button-primary active:shadow-none lumon:active:bg-gray-500 lumon:active:text-gray-0', // active
  'sm:block hidden data-[can-scroll=false]:hidden' // conditional show/hide ( mobile hide )
];

export const backButton = [...baseButton, 'absolute left-4 top-1/2 -translate-y-1/2 lumon:-left-4 lumon:top-1/3'];

export const forwardButton = [...baseButton, 'absolute right-4 top-1/2 -translate-y-1/2 lumon:-right-4 lumon:top-1/3'];
